import React, {useContext, useEffect} from 'react';
import {Spin} from 'antd';
import {useNavigate, Link} from 'react-router-dom';
import {useIntl} from 'react-intl';
import {AlertContext} from '../context/AlertContext';
import {ALERT_DURATIONS} from '../constants/alerts';

const GoogleCalendarCallback: React.FC = () => {
    const navigate = useNavigate();
    const intl = useIntl();
    const {setSuccessMessage, setVisible, setError, setRedirectUrl} = useContext(AlertContext);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const success = params.get('success');
        const error = params.get('error');
        const emailParam = params.get('email');
        const imported = params.get('imported') || '0';
        const skipped = params.get('skipped') || '0';
        const failed = params.get('failed') || '0';

        if (success === 'true') {
            // Send success message to parent window (if opened in popup)
            if (window.opener) {
                window.opener.postMessage({
                    type: 'google-calendar-oauth',
                    success: true,
                    email: emailParam,
                    imported: parseInt(imported),
                    skipped: parseInt(skipped),
                    failed: parseInt(failed)
                }, window.location.origin);

                // Close popup after brief delay
                setTimeout(() => {
                    window.close();
                }, 1000);
            } else {
                // Not a popup - show big green banner with import stats
                const totalImported = parseInt(imported);
                const totalSkipped = parseInt(skipped);
                const totalFailed = parseInt(failed);

                let baseMsg = intl.formatMessage({id: 'googleCalendarConnectedSuccess'});

                // Include import stats in the message
                if (totalImported > 0 || totalSkipped > 0 || totalFailed > 0) {
                    baseMsg += ` ${totalImported} ${intl.formatMessage({id: 'eventsImported'})}, ${totalSkipped} ${intl.formatMessage({id: 'eventsSkipped'})}, ${totalFailed} ${intl.formatMessage({id: 'eventsFailed'})}`;
                }

                // Add activity log link
                const successMsg = (
                    <>
                        {baseMsg}
                        {' '}
                        <Link to="/activity-log" style={{ fontWeight: 'bold' }}>
                            {intl.formatMessage({id: 'checkActivityLogForDetails'})}
                        </Link>
                    </>
                );

                setSuccessMessage(successMsg);
                setVisible(true);
                setRedirectUrl('/organization');

                // Redirect to organization settings after showing alert (extended duration for link)
                setTimeout(() => {
                    navigate('/organization');
                }, ALERT_DURATIONS.WITH_LINK);
            }
        } else if (error) {
            // Send error message to parent window (if opened in popup)
            if (window.opener) {
                window.opener.postMessage({
                    type: 'google-calendar-oauth',
                    success: false,
                    error: decodeURIComponent(error)
                }, window.location.origin);

                // Don't auto-close on error, let user see the error
            } else {
                // Not a popup - show error alert and redirect
                setError(decodeURIComponent(error));
                setVisible(true);

                // Redirect back to organization settings after 3 seconds
                setTimeout(() => {
                    navigate('/organization');
                }, 3000);
            }
        }
    }, [navigate, intl, setSuccessMessage, setVisible, setError, setRedirectUrl]);

    // Show loading spinner while processing
    return (
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh'}}>
            <Spin size="large"/>
        </div>
    );
};

export default GoogleCalendarCallback;
